import { i18n } from "@lingui/core";
import { messages as enMessages } from "../../locales/en-US/messages.mjs";
import { messages as koMessages } from "../../locales/ko-KR/messages.mjs";

// Synchronously load default locale messages to avoid race conditions
// This ensures i18n is ready before any component tries to use it
i18n.load({
  "en-US": enMessages,
  "ko-KR": koMessages,
});

// Activate default locale
i18n.activate("en-US");

export { i18n };
